module.exports = __webpack_public_path__ + "web/img/code.47bb9693.jpg";